import { Input, Spin, Tag, Tooltip } from "antd"
import React, { useEffect, useRef, useState } from "react"
import { PlusOutlined } from "@ant-design/icons"
import "./ProductUnits.less"
import { useTranslation } from "react-i18next"
import useCategory from "../../../../hooks/useCategory"
import { InputRef } from "rc-input"

export default function ProductCategories() {
  const [inputValue, setInputValue] = useState("")
  const [editInputIndex, setEditInputIndex] = useState(-1)
  const { categories, deleteCategory, createCategory, updateCategory } =
    useCategory({ SearchText: inputValue }, editInputIndex)
  const [inputVisible, setInputVisible] = useState(false)
  const [editInputValue, setEditInputValue] = useState("")
  const saveEditInputRef = useRef<InputRef>(null)
  const saveInputRef = useRef<InputRef>(null)
  const { t } = useTranslation()
  useEffect(() => {
    categories.refetch()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  async function handleClose(removedTag: number) {
    await deleteCategory.mutate(String(removedTag))
    refetchUnits()
  }
  function showInput() {
    setInputVisible(() => {
      // saveInputRef?.current?.focus();
      return true
    })
  }
  async function handleInputConfirm() {
    if (inputValue.length < 3) return
    await createCategory.mutate({ name: inputValue })
    refetchUnits()
    setInputVisible(false)
    setInputValue("")
  }
  async function handleEditInputConfirm() {
    await updateCategory.mutate({
      id: editInputIndex,
      name: editInputValue,
    })
    refetchUnits()
    setEditInputValue("")
    setEditInputIndex(-1)
  }
  async function refetchUnits() {
    return await categories.refetch()
  }
  return (
    <Spin
      spinning={
        categories.isLoading ||
        deleteCategory.isLoading ||
        createCategory.isLoading ||
        updateCategory.isLoading
      }
    >
      {categories?.data?.data?.map((node) => {
        const nodeId = node?.id || -2
        const nodeName = node?.name || ""
        if (editInputIndex === nodeId) {
          return (
            <Input
              ref={saveEditInputRef}
              key={node?.name}
              className="tag-input"
              size="small"
              value={editInputValue}
              onChange={(e) => setEditInputValue(e.target.value)}
              onBlur={handleEditInputConfirm}
              onPressEnter={handleEditInputConfirm}
            />
          )
        }
        const isLongTag = nodeName.length > 20
        const tagElem = (
          <Tag
            className="edit-tag"
            key={nodeName}
            closable={nodeId !== 0}
            onClose={() => handleClose(nodeId)}
          >
            <span
              onDoubleClick={(e) => {
                if (nodeId !== 0) {
                  setEditInputIndex(nodeId)
                  setEditInputValue(nodeName)
                  // saveEditInputRef;
                  e.preventDefault()
                }
              }}
            >
              {isLongTag ? `${nodeName?.slice(0, 20)}...` : nodeName}
            </span>
          </Tag>
        )
        return isLongTag ? (
          <Tooltip title={nodeName} key={nodeId}>
            {tagElem}
          </Tooltip>
        ) : (
          tagElem
        )
      })}
      {inputVisible && (
        <Input
          ref={saveInputRef}
          type="text"
          size="small"
          className="tag-input"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onBlur={handleInputConfirm}
          onPressEnter={handleInputConfirm}
        />
      )}
      {!inputVisible && (
        <Tag className="site-tag-plus" onClick={showInput}>
          <PlusOutlined /> {t("add")}
        </Tag>
      )}
    </Spin>
  )
}
